export const SITE_URL = 'https://theacmpros.com'

export const CANONICAL_HOSTS = ['theacmpros.com', 'www.theacmpros.com']

export const BUSINESS = {
    name: "The ACM Pros",
    legalName: "ACM Services LLC",
    tagline: "A home worth coming home to",
    footerTagline: "Excellence you can see. Service you can trust.",
    phone: "(256) 585-6817",
    phoneHref: 'tel:+12565856817',
    phoneE164: '+12565856817',
    license: "307601",
    licenseLabel: "Alabama license #307601",
    founded: 2019,
    base: "Madison, Alabama",
    locality: "Madison",
    region: "AL",
    regionName: "Alabama",
    country: "US",
    owners: "Brad and Chase Miller",
    ownersDetail: "Brad and Chase Miller, father and son",
    crews: 2,
    hoursText: "Monday to Saturday, 7 AM to 7 PM. Closed Sunday.",
    hoursShort: "Mon to Sat, 7 AM to 7 PM",
    openDays: [1, 2, 3, 4, 5, 6],
    openHour: 7,
    closeHour: 19,
    timeZone: 'America/Chicago',
    googleReviewsUrl: 'https://www.google.com/maps?cid=12495287045608811732',
    facebookUrl: 'https://www.facebook.com/ACMPros',
    instagramUrl: 'https://www.instagram.com/acmpros/'
} as const

export const EXTERIOR_ONLY = {
    short: "Exterior windows and exterior doors only.",
    statement: "We only work on the outside of your home. We replace exterior windows and install exterior doors. We do not install interior doors or interior windows, and we do not do interior remodeling.",
    weDo: [
        "Replace the windows in your home's outside walls",
        "Install exterior entry, patio, French and storm doors",
        "Fit exterior storm windows and exterior shutters",
        "Side, roof and wash the outside of your home"
    ],
    weDont: [
        "Install interior doors, such as bedroom, closet or bathroom doors",
        "Install interior windows or glass between rooms",
        "Do interior remodeling, trim carpentry or painting inside",
        "Work in Tennessee"
    ]
} as const

export const SERVICE_LINES = [
    {
        slug: 'exterior-windows-doors',
        category: 'windows-doors',
        name: "Exterior Windows & Doors",
        short: "Windows & Doors",
        href: '/windows-doors/',
        summary: "Exterior window replacement and exterior door installation, measured and fitted so every opening stays dry. Outside work only."
    },
    {
        slug: 'siding',
        category: 'siding',
        name: "Siding",
        short: "Siding",
        href: '/services/siding/',
        summary: "New siding with the moisture protection behind it done right, including fiber cement, soffit and fascia."
    },
    {
        slug: 'roofing',
        category: 'roofing',
        name: "Roofing",
        short: "Roofing",
        href: '/services/roofing/',
        summary: "Roof replacement and ventilation built for North Alabama heat, humidity and storms."
    },
    {
        slug: 'pressure-soft-washing',
        category: 'washing',
        name: "Pressure & Soft Washing",
        short: "Washing",
        href: '/services/pressure-washing/',
        summary: "Soft washing for siding and roofs, pressure washing for concrete. Years of grime come off without damage."
    }
] as const

export const WHY_CHOOSE = [
    {
        title: "Local, not regional",
        text: "We work Madison, Huntsville and nearby towns. You are not paying for someone to drive ninety miles to your house."
    },
    {
        title: "No high-pressure estimate",
        text: "You will not be asked to sign tonight. The price is the same next week."
    },
    {
        title: "A written scope",
        text: "Every job is written down line by line with the materials named, so the number you agree to is the number you pay."
    },
    {
        title: "We show you what we find",
        text: "If we find rot or damage behind the old work, we stop, take photos and show you before anything is covered up."
    },
    {
        title: "Two crews, one job each",
        text: "Each crew stays on one job until it is finished. Nobody disappears halfway through."
    },
    {
        title: "Your whole exterior",
        text: "Windows, siding and roofing work together to keep water out, so we look at how they meet, not just the part you called about."
    }
] as const

export const JOB_STEPS = [
    {
        title: "Free in-home estimate",
        text: "We walk your exterior, measure, and show you the options. There is no charge and no pressure."
    },
    {
        title: "Choose your materials",
        text: "You get a written scope with every line and material named. Then we order for your home."
    },
    {
        title: "Installed and cleaned up",
        text: "Cut, fitted, trimmed, cleaned up and hauled away the same day. You never look at a pile of old frames."
    }
] as const
